<sepidz-review class="review" showDateFilter="false">
  <div review-filters>
    <div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('FilterDocument')">
          <span>فیلتر کارکنان</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'FilterDocument'"></i>
        </div>
        <div *ngIf="selected === 'FilterDocument'">
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              valueType="array"
              [form]="formGroup"
              title="از سال"
              name="StartYear"
              key="StartYear"
              apiName="FiscalYear/FiscalYear"
              textFieldName="Year"
              valueFieldName="Year"
              [items]="[{ Name: 'از سال' }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              valueType="array"
              [form]="formGroup"
              title="از ماه"
              name="StartMonth"
              key="StartMonth"
              apiName="MonthsName"
              [items]="[{ Name: 'از ماه' }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              valueType="array"
              [form]="formGroup"
              title="تا سال"
              name="EndYear"
              key="EndYear"
              apiName="FiscalYear/FiscalYear"
              textFieldName="Year"
              valueFieldName="Year"
              [items]="[{ Name: 'تا سال' }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              valueType="array"
              [form]="formGroup"
              title="تا ماه"
              name="EndtMonth"
              key="EndtMonth"
              apiName="MonthsName"
              [items]="[{ Name: 'تا ماه' }]">
            </sepidz-static-select-review>
          </section>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('DocumentType')">
          <span>نوع استخدام</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'DocumentType'"></i>
        </div>
        <div *ngIf="selected === 'DocumentType'">
          <sepidz-remote-select-review
            title="نوع استخدام"
            [form]="formGroup"
            name="EmploymentKind"
            key="EmploymentKindIds"
            apiName="EmploymentKind/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('DocumentStatus')">
          <span>محل خدمت</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'DocumentStatus'"></i>
        </div>
        <div *ngIf="selected === 'DocumentStatus'">
          <sepidz-remote-select-review title="محل خدمت" [form]="formGroup" name="Workplace" key="WorkplaceIds" apiName="Workplace/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('SystemType')">
          <span>مرکز هزینه</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'SystemType'"></i>
        </div>
        <div *ngIf="selected === 'SystemType'">
          <sepidz-remote-select-review title="مرکز هزینه" [form]="formGroup" name="CostCenter" key="CostCenterIds" apiName="CostCenter/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('Branch')">
          <span>طبقه عامل</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'Branch'"></i>
        </div>
        <div *ngIf="selected === 'Branch'">
          <sepidz-remote-select-review
            title="طبقه عامل"
            [form]="formGroup"
            name="ElementGroup"
            key="ElementGroupIds"
            apiName="Lookup"
            systemName="HRM"
            (onChange)="onChange($event)"
            category="ElementGroup">
          </sepidz-remote-select-review>
        </div>
      </div>
    </div>
  </div>
  <div review-content>
    <ssg-tabset class="tabset" (tabChange)="selectTab($event)">
      <ssg-tab *hasPermission="['Payroll:HrmReview/GetHrmReviewTotallReport', 'Same']" [active]="isActveTab('سرجمع')" tabTitle="سرجمع">
        <sepidz-grid-review
          *ngIf="isActveTab('سرجمع')"
          name="GetHrmReviewTotallReport"
          title="سرجمع"
          apiName="HrmReview/GetHrmReviewTotallReport"
          areaName="Payroll"
          [columns]="HrmReviewColumns"
          displayNameColumn="PersCode"
          pathPreFix="HRM"
          key="TotallHrmPersonnelIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab *hasPermission="['Payroll:HrmReview/GetHrmReviewCurrentMonthReport', 'Same']" [active]="isActveTab('ماه جاری')" tabTitle="ماه جاری">
        <sepidz-grid-review
          *ngIf="isActveTab('ماه جاری')"
          name="GetHrmReviewCurrentMonthReport"
          title="ماه جاری"
          apiName="HrmReview/GetHrmReviewCurrentMonthReport"
          areaName="Payroll"
          [selective]="false"
          [columns]="HrmReviewColumns"
          pathPreFix="HRM">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab *hasPermission="['Payroll:HrmReview/GetHrmReviewBackPayReport', 'Same']" [active]="isActveTab('معوقه')" tabTitle="معوقه">
        <sepidz-grid-review
          *ngIf="isActveTab('معوقه')"
          name="GetHrmReviewBackPayReport"
          title="معوقه"
          apiName="HrmReview/GetHrmReviewBackPayReport"
          areaName="Payroll"
          [selective]="false"
          [columns]="HrmReviewColumns"
          pathPreFix="HRM">
        </sepidz-grid-review>
      </ssg-tab>
    </ssg-tabset>
  </div>
</sepidz-review>
